<div
  #dialogContainer
  class="iu-info-dialog-background"
  [ngStyle]="{ display: isOpen ? 'block' : 'none' }"
  (click)="cancelDialog()"></div>
<p-toast position="center" [baseZIndex]="baseZIndex" [key]="key">
  <ng-template let-message pTemplate="message">
    <div class="info-dialog-content">
      @if (dialogType === 'confirm' || dialogType === 'confirmyesno') {
        <i aria-hidden="true" class="fa fa-exclamation-triangle fa-3x"></i>
      } @else if (dialogType === 'info') {
        <i aria-hidden="true" class="fa fa-info-circle fa-3x"></i>
      } @else if (dialogType === 'error') {
        <i aria-hidden="true" class="fa fa-times-circle fa-3x"></i>
      }
      <h3>{{ message.summary }}</h3>
      <p [innerHTML]="message.detail"></p>
    </div>
    <div class="info-dialog-buttons apiz-p-grid ui-fluid">
      @switch (dialogType) {
        @case ('confirm') {
          <div class="p-col-6">
            <button
              class="p-button-secondary"
              data-cy="info-dialog-cancel-btn"
              pButton
              type="button"
              [attr.data-cy-type]="dialogType"
              label="{{ 'infodialog.cancel' | translate }}"
              (click)="cancelDialog()"></button>
          </div>
          <div class="p-col-6">
            <button
              #confirm
              class="p-button p-button-primary"
              data-cy="info-dialog-confirm-btn"
              pButton
              type="button"
              [attr.data-cy-type]="dialogType"
              label="{{ 'infodialog.ok' | translate }}"
              (click)="confirmDialog()"></button>
          </div>
        }
        @case ('confirmyesno') {
          <div class="p-col-6">
            <button
              class="p-button-secondary"
              data-cy="info-dialog-cancel-btn"
              pButton
              type="button"
              [attr.data-cy-type]="dialogType"
              label="{{ 'infodialog.no' | translate }}"
              (click)="cancelDialog()"></button>
          </div>
          <div class="p-col-6">
            <button
              #confirmYesNo
              class="p-button p-button-primary"
              data-cy="info-dialog-confirm-btn"
              pButton
              type="button"
              [attr.data-cy-type]="dialogType"
              label="{{ 'infodialog.yes' | translate }}"
              (click)="confirmDialog()"></button>
          </div>
        }
      }

      @if (dialogType !== 'confirm' && dialogType !== 'confirmyesno') {
        <div class="p-col-12">
          <button
            #confirmOK
            class="p-button p-button-primary"
            data-cy="info-dialog-OK-btn"
            pButton
            type="button"
            [attr.data-cy-type]="dialogType"
            label="{{ 'infodialog.ok' | translate }}"
            (click)="confirmDialog()"></button>
        </div>
      }
    </div>
  </ng-template>
</p-toast>
